<template>
  <div>
    <vs-chip v-if="gelenval == 'Aktif'" color="success" >
      {{ gelenval }}
    </vs-chip>
    <vs-chip v-else color="danger">
      {{ gelenval }}
    </vs-chip>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      gelenval: "",
    };
  },
  methods: {
    gelenData() {
      this.gelenval = this.params.data.durum == 0 ? "Pasif" : "Aktif";
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
<style lang="scss">
.chip {
  display: inline-block;
  padding: 0 25px;
  height: 25px;
  font-size: 10px;
  line-height: 25px;
  border-radius: 25px;
  background-color: #7367f0;
  color: white;
}
</style>